<template>
  <div>
    <div class="d-flex justify-end">
      <v-btn
        class="primary-button ml-2"
        depressed
        @click="showFilter = !showFilter"
      >
        {{ showFilter ? 'Fechar filtros' : 'Filtros' }}
      </v-btn>
    </div>

    <v-expand-transition>
      <div v-if="showFilter">
        <div class="my-2 d-flex justify-end align-center">
          <v-text-field
            v-model="filter.search"
            placeholder="Pesquise pelo nome do padrão, nome do equipamento ou identificação do equipamento"
            class="primary-input mt-4"
            outlined
            style="max-width: 700px"
            hide-details
          ></v-text-field>
          <v-btn
            class="ma-0 primary-button ml-2"
            depressed
            @click=";(page = 1), list()"
          >
            Filtrar
          </v-btn>
        </div>
      </div>
    </v-expand-transition>

    <v-data-table
      :headers="headers"
      :items="patterns"
      class="main-table"
      hide-default-footer
      :items-per-page="pageSize"
      :loading="loading"
      :header-props="headerProps"
    >
      <template #[`item.status`]="{ item }">
        <v-chip class="pa-2" :color="getColor(item.status)">
          <span style="font-size: 12px">{{ statusList[item.status] }}</span>
        </v-chip>
      </template>

      <template #[`item.name`]="{ item }">
        {{ item.name }}
      </template>

      <template #[`item.calibrationV2Pattern.expirationDate`]="{ item }">
        <div class="d-flex flex-column align-center">
          <span>{{ formatDate(item.calibrationV2Pattern.expirationDate) }}</span>
          <v-chip
            v-if="isExpired(item.calibrationV2Pattern.expirationDate)"
            x-small
            color="error"
            dark
            class="mt-1"
          >
            Vencido
          </v-chip>
        </div>
      </template>
    </v-data-table>

    <div class="pagination">
      <div class="item-pagination block-one">
        <v-menu bottom offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              class="btn"
              depressed
              color="#C0C0C0"
              small
            >
              qtd: {{ pageSize }}
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              v-for="(size, i) in sizes"
              :key="i"
              @click="pageSize = size"
            >
              <v-list-item-title>{{ size }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <div class="registros" v-if="totalItensOnPage">
          <span> {{ pageStart }} - {{ pageEnd }} de {{ totalItems }} </span>
        </div>
      </div>

      <div class="item-pagination block-two">
        <v-pagination
          class="pagination-item"
          v-model="page"
          :length="totalPages"
          :total-visible="9"
        ></v-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import ApiService from '../../../../../services/ApiService'

export default {
  name: 'institutionPatternTable',

  data() {
    return {
      showFilter: false,
      patterns: [],
      pageSize: 10,
      sizes: [10, 25, 50],
      totalItems: 4,
      totalItensOnPage: 4,
      totalPages: 1,
      page: 1,
      loading: false,
      filter: {
        page: 1,
        pageSize: 10,
      },
      apiService: new ApiService(),
      headerProps: {
        sortByText: 'Ordenar por',
      },
      statusList: [
        'Aprovado',
        'Desaprovado',
        'Aguardando aprovação',
        'Não encontrado',
      ],
      headers: [
        { text: '', align: 'center', value: '', sortable: false },
        {
          text: 'Status',
          align: 'center',
          value: 'status',
          sortable: false,
        },
        {
          text: 'Instituição',
          align: 'center',
          value: 'calibrationV2Pattern.institution.name',
          sortable: false,
        },
        {
          text: 'Padrão',
          align: 'center',
          value: 'calibrationV2Pattern.name',
          sortable: false,
        },
        {
          text: 'Equipamento',
          align: 'center',
          value: 'calibrationV2Pattern.equipment.identification',
          sortable: false,
        },
        {
          text: 'Validade',
          align: 'center',
          value: 'calibrationV2Pattern.expirationDate',
          sortable: false,
        },
      ],
    }
  },

  created() {
    this.filter.institutionId = JSON.parse(
      localStorage.getItem('institution')
    ).id
    this.list()
  },

  methods: {
      isExpired(date) {
        if (!date) return false;
        return moment(date).isBefore(moment(), 'day');
      },
    getColor(status) {
      switch (status) {
        case 0:
          return 'secondary'
        case 1:
          return 'error'
        case 2:
          return 'accent'
        default:
          return 'info'
      }
    },

    list() {
      this.loading = true
      this.apiService
        .get('calibration/v2/pattern/made-requests', this.filter)
        .then((response) => {
          this.loading = false
          this.patterns = response.content.data
          this.totalItems = response.content.pager.totalItems

          const start = (this.page - 1) * this.pageSize + 1
          const end = Math.min(this.page * this.pageSize, this.totalItems)
          this.pageStart = start
          this.pageEnd = end

          this.totalPages = Math.ceil(this.totalItems / this.pageSize)
        })
        .catch(() => {
          this.loading = false
        })
    },

    formatDate(date) {
      if (date) return moment(date).format('DD/MM/yyyy')
      else return 'Sem registro'
    },

    viewItem(item) {
      console.log('Visualizar item', item)
    },
  },

  watch: {
    page() {
      this.filter.page = this.page
      this.list()
    },

    pageSize() {
      this.filter.pageSize = this.pageSize
      this.list()
    },
  },
}
</script>

<style></style>
